
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 20 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.334 17.868c-3.498 0-5.433-.658-5.77-1.039.295-3.2 2.57-5.234 5.827-5.234 1.058 0 2 .186 2.8.553a5.633 5.633 0 012.145-1.024 5.655 5.655 0 00-1.185-.845c.806-.867 1.61-1.996 1.61-3.961 0-3.065-2.409-5.56-5.37-5.56-2.962 0-5.371 2.495-5.371 5.56 0 1.967.936 3.07 1.687 3.941-2.42 1.264-3.972 4.48-3.972 6.645 0 2.577 5.314 2.857 7.6 2.857.436 0 .984-.01 1.584-.046a5.617 5.617 0 01-.788-1.86c-.257.008-.52.013-.797.013zm.057-15.217c1.953 0 3.542 1.645 3.542 3.667s-1.589 3.667-3.542 3.667c-1.954 0-3.542-1.645-3.542-3.667S6.437 2.65 8.39 2.65z"}}),_c('path',{attrs:{"d":"M19.265 17.242v-1.245l-.673-.24a.964.964 0 01-.547-1.322l.306-.644-.88-.88-.645.306a.965.965 0 01-1.322-.547l-.24-.673H14.02l-.24.673a.964.964 0 01-1.322.547l-.643-.306-.881.88.306.645a.962.962 0 01-.547 1.322l-.672.239v1.245l.673.239a.962.962 0 01.546 1.322l-.306.645.88.88.645-.306a.962.962 0 011.322.547l.24.673h1.245l.237-.669a.975.975 0 01.544-.572.955.955 0 01.776.018l.648.31.88-.881-.306-.645a.965.965 0 01.548-1.322l.673-.24zm-4.622 1.072a1.695 1.695 0 11-.002-3.39 1.695 1.695 0 01.002 3.39z"}})])
          )
        }
      }
    